import { jsx as n, jsxs as _ } from "react/jsx-runtime";
import { memo as a } from "react";
import c from "clsx";
import { useModalContext as m } from "./ModalContext.js";
import '../../_assets/ModalContent.CheMnZg2.css';const p = "_main_pz9yd_44", y = "_noBackground_pz9yd_51", v = "_scrollBlock_pz9yd_55", z = "_isFooter_pz9yd_77", g = "_center_pz9yd_78", u = "_noFooter_pz9yd_88", D = "_centerLarge_pz9yd_97", k = "_titleDividerContainer_pz9yd_106", B = "_titleDivider_pz9yd_106", e = {
  main: p,
  noBackground: y,
  scrollBlock: v,
  isFooter: z,
  center: g,
  noFooter: u,
  centerLarge: D,
  titleDividerContainer: k,
  titleDivider: B,
  "slide-in-out": "_slide-in-out_pz9yd_1",
  "fade-in-out": "_fade-in-out_pz9yd_1"
}, f = a(
  ({ children: d, hasFooter: t, noPadding: r, noBackground: s = !1, className: l }) => {
    const { mode: o, titleDivider: i } = m();
    return /* @__PURE__ */ n(
      "div",
      {
        className: c(e.main, {
          [e.noBackground]: s
        }),
        children: /* @__PURE__ */ _(
          "div",
          {
            className: c(
              e.scrollBlock,
              {
                [e.center || ""]: o === "center",
                [e.titleDividerContainer || ""]: i,
                [e.centerLarge || ""]: o === "centerLarge",
                [e.isFooter || ""]: t && !r && o === "right",
                [e.noFooter || ""]: !t && !r && o === "right"
              },
              l
            ),
            children: [
              i && /* @__PURE__ */ n("div", { className: e.titleDivider }),
              d
            ]
          }
        )
      }
    );
  }
);
f.displayName = "ModalContent";
export {
  f as ModalContent
};
